module.exports = __webpack_public_path__ + "static/img/ico-nubank.6366235.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/bancos/ico-nubank.png
// module id = Mw2E
// module chunks = 0